import { render, staticRenderFns } from "./editorFile.vue?vue&type=template&id=10a86fbb&scoped=true&"
import script from "./editorFile.vue?vue&type=script&lang=js&"
export * from "./editorFile.vue?vue&type=script&lang=js&"
import style0 from "./editorFile.vue?vue&type=style&index=0&id=10a86fbb&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a86fbb",
  null
  
)

export default component.exports